/**
 * Utility Functions for Class Merging
 * 
 * @description
 * Helper functions for composing Tailwind CSS classes.
 * These utilities are used throughout the component library.
 * 
 * @module lib/utils
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges multiple class values using clsx and tailwind-merge.
 * Handles conflicts between Tailwind classes intelligently.
 * 
 * @param {...ClassValue} inputs - Class values to merge
 * @returns {string} Merged class string
 * 
 * @example
 * ```tsx
 * <button className={cn("px-4 py-2", isActive && "bg-neon-cyan")}>
 *   Click me
 * </button>
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}